module.exports = ".kids-logo {\n  padding-left: 50px;\n  padding-top: 50px;\n  height: 40px;\n  width: 120px;\n}\n.navCol{\n  background: lightblue;\n}"